import { useEditorState } from '@tiptap/react'
import { VFC, useMemo } from 'react'
import { useTheme } from '@opallabs/hooks'
import { useTextEditor } from '../../TextEditor/context'
import { CharacterCountDisplayProps } from '../types'
import * as styles from './styles'

export const CharacterCountDisplay: VFC<CharacterCountDisplayProps> = ({
  limit,
  isSoftLimit = false,
  position = 'right',
  offset = 42,
  zIndex = 'auto',
}) => {
  const theme = useTheme()
  const { editor } = useTextEditor()
  const { showCounter, textLength } = useEditorState({
    editor,
    selector: (snapshot) => ({
      showCounter: snapshot.editor.isEditable && snapshot.editor.isFocused,
      textLength: snapshot.editor.storage.characterCount.characters,
    }),
  })

  const counterColor = useMemo(() => {
    return styles.getCounterColor(limit, textLength, isSoftLimit)
  }, [limit, textLength, isSoftLimit])

  if (!showCounter) {
    return null
  }

  return (
    <div
      css={styles.characterCount({
        theme,
        position,
        offset,
        zIndex,
      })}
      style={{ backgroundColor: counterColor, borderColor: counterColor }}
    >
      {(limit - textLength).toLocaleString()}
    </div>
  )
}
